import { AttachmentStore } from '@/stores/attachment/store';
import { CallsStore } from '@/stores/calls/store';
import { EnvironmentStore } from '@/stores/environment/store';
import { ImportStore } from '@/stores/import/store';
import { NotificationStore } from '@/stores/notification/store';
import { PartnerPracticesStore } from '@/stores/partner-practices/store';
import { SettingsStore } from '@/stores/settings/store';
import { TypesStore } from '@/stores/types/store';
import { UserStore } from '@/stores/user/store';
import { UsersStore } from '@/stores/users/store';
import Vue from 'vue';
import Vuex, { ActionContext } from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        attachment: new AttachmentStore(),
        calls: new CallsStore(),
        environment: new EnvironmentStore(),
        import: new ImportStore(),
        notification: new NotificationStore(),
        partnerPractices: new PartnerPracticesStore(),
        settings: new SettingsStore(),
        types: new TypesStore(),
        user: new UserStore(),
        users: new UsersStore(),
    },
    state: {
        isLoading: true,
        isDirty: false,
    },
    mutations: {
        isLoading: (state: any, loading: boolean) => {
            state.isLoading = loading;
        },
        setDirty: (state: any, dirty: boolean) => {
            state.isDirty = dirty;
        },
    },
    actions: {
        isLoading: (context: ActionContext<any, any>, loading: boolean) => {
            context.commit('isLoading', loading);
        },
    },
    getters: {
        isLoading: (state: any) => state.isLoading,
        isDirty: (state: any) => state.isDirty,
    },
});
